import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { UndergradLessonState } from './state';
import { UndergradLesson, LessonItem } from '@/models/undergrad/undegrad-lesson.model';

const getters: GetterTree<UndergradLessonState, RootState> = {
  undergradLessons: (state: UndergradLessonState): UndergradLesson[] => {
    return Object.values(state.undergradLessons);
  },
  lessonById:
    (state: UndergradLessonState) =>
    (id: string): UndergradLesson | undefined =>
      state.undergradLessons[id],
  lessonBySlug:
    (state: UndergradLessonState) =>
    (lessonSlug: string): UndergradLesson | undefined => {
      return Object.values(state.undergradLessons).find(
        (lesson: UndergradLesson) => lesson.slug === lessonSlug,
      );
    },
  lessonItems:
    (state: UndergradLessonState) =>
    (lessonSlug: string): LessonItem[] | undefined => {
      return Object.values(state.undergradLessons).find(
        (lesson: UndergradLesson) => lesson.slug === lessonSlug,
      )?.items;
    },
};

export default getters;
